export default ngModule => {

  ngModule.factory('AonProducts', function (AonApi, OperatorService, PrimaryServiceNeeds, $q) {

    class AonProducts {

      constructor() {
        this.services = null;

        // Cached applicant used for fetching preselect services. Used to track changes to see if we need to refetch.
        this.cachedApplicant = {};
      }

      saveServices(services) {
        this.services = _.cloneDeep(services);
      }

      /**
       * Get full list of services
       * @returns {*}
       */
      getServices() {
        const deferred = $q.defer();
        if (this.services === null) {
          const success = (response) => {
            this.services = response.data;
            this.services.hospital = this.services.hospital.map( s => { s.selected = false; return s; });
            this.services.ancillary = this.services.ancillary.map( s => { s.selected = false; return s; });
            deferred.resolve(this.services);
          },
          error = (data) => {
            deferred.reject();
          };
          AonApi.get('services').then(success, error);
        } else {
          deferred.resolve(this.services);
        }
        return deferred.promise;
      }

      /**
       * Get full list of services with selected ones flagged with 'selected' key
       *
       * @param applicant
       * @returns {*}
       */
      getPreselectedServices(applicant) {
        const deferred = $q.defer();
        const zohoServices = _.get(applicant, 'zoho.services', null);

        this.getServices().then(services => {

          const setServices = data => {
            this.cachedApplicant = applicant;
            let updated_services = {};

            for (let type of ['ancillary', 'hospital']) {
              const ids = _.map(data[type], 'id');
              updated_services[type] = _(services[type]).map(service => {
                service.selected = (ids.indexOf(service.id) !== -1);
                return service;
              }).value();
            }
            this.services = updated_services;
          };

          if (_.isEqual(applicant, this.cachedApplicant)) {
            deferred.resolve(this.services);
          } else {
            const primaryNeed = _.get(applicant, 'policy.primary_service_need', null);

            if (primaryNeed) {
              this.services = PrimaryServiceNeeds.selectPrimaryNeedServices(this.services, primaryNeed);
              const need = PrimaryServiceNeeds.needFromCode(primaryNeed);
              OperatorService.setSelectedTiers(need.hospital_tiers)
            }

            // If we have selected services from a saved quote in zoho, overwrite whatever
            // was selected (or not) from the primary service need (has to come after the
            // primaryNeed block above)
            if (zohoServices !== null) {
              setServices(zohoServices);
            }

            deferred.resolve(this.services);
          }
        });

        return deferred.promise
      }

      /**
       * Search for pricing packages
       *
       * @param application AonApplication
       * @param selectedServices
       * @returns {*}
       */
      searchPackages(application, selectedServices, filters) {
        const ancillary = _.pluck(selectedServices.ancillary, 'id'),
              hospital = _.pluck(selectedServices.hospital, 'id');
        return AonApi.post('packages/search', {
          application,
          services: {
            ancillary,
            hospital,
          },
          current_fund_id: _.get(application, 'personal.previous_fund.fund_id', ''),
          filters: filters
        });
      }

    }

    return new AonProducts();

  });


};



// WEBPACK FOOTER //
// ./src/services/products-service.js